import { EndpointGuard } from '../../helpers/auth';
import { deliveryAttemptsCollectionGuard } from './_api/deliveryAttempts';

export const routeGuard: EndpointGuard = [deliveryAttemptsCollectionGuard]; // add here deliveryAttempts
